import React from 'react';
import styles from './styles.module.scss';
import { Button } from '@mui/material';
import { useHistory } from 'react-router-dom';
import { useTranslation } from '../../../i18n/LanguageProvider';

const Registered = () => {
  const { t } = useTranslation();
  const history = useHistory();
  return (
    <div>
      <h1>{t('auth.registered')}</h1>

      <Button
        fullWidth
        variant="contained"
        className={styles.formItem}
        onClick={() => history.replace('/login')}
      >
        {t('auth.login')}
      </Button>
    </div>
  );
};

export default Registered;
